import * as h2Api from '../../h2Api'
import * as actions from '../../actions/admin/adminUserActions.js'

const initialState = {
  groupReport: null,
  commonReport: null,
  data: null,
  filter: {}
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case actions.CLEAR_REPORT_SELECTION: {
      return {
        ...state,
        ...initialState
      }
    }

    case actions.REPORT_SELECTION: {
      let reportModal = {}

      if (action.typeId === 'GROUP') {
        reportModal = {
          groupReport: action.reportId,
          commonReport: null
        }
      } else if (action.typeId === 'COMMON') {
        reportModal = {
          commonReport: action.reportId,
          groupReport: null
        }
      }

      return {
        ...state,
        ...reportModal
      }
    }

    case actions.REPLACE_FILTER: {
      console.log(action)

      return {
        ...state,
        filter: action.value
      }
    }

    case actions.UPDATE_FILTER_PARAM: {
      console.log(state.filter, action)
      const f = {
        ...state,
        filter: {
          ...state.filter,
          [action.key]: action.value
        }
      }

      console.log(f, action)

      return f
    }

    case actions.REPORT_GROUP_DEFAULT_DATA_LOAD: {
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const results = action.restCall.result

        console.log(results)
        const { filter, ...other } = results

        return {
          ...state,
          data: other,
          filter: filter || {}
        }
      }

      return state
    }

    default:
      return state
  }
}

export default reducers
